"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _Special = _interopRequireDefault(require("../../molecules/Special"));
require("./Specials.css");
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var Specials = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Specials, _React$Component);
  var _super = _createSuper(Specials);
  function Specials() {
    (0, _classCallCheck2["default"])(this, Specials);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(Specials, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        color = _this$props.color,
        btnText = _this$props.btnText,
        btnAction = _this$props.btnAction,
        specials = _this$props.specials,
        type = _this$props.type,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, ["color", "btnText", "btnAction", "specials", "type"]);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h1",
        align: "center"
      }, "Specials"), /*#__PURE__*/_react["default"].createElement(_Special["default"], (0, _extends2["default"])({
        specials: specials,
        type: type
      }, rest)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "specials-order-button"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        color: color,
        onClick: btnAction,
        size: "large"
      }, btnText)));
    }
  }]);
  return Specials;
}(_react["default"].Component);
Specials.propTypes = {
  specials: _propTypes["default"].shape({
    schedules: _propTypes["default"].array,
    categories: _propTypes["default"].array,
    items: _propTypes["default"].array,
    modifierSets: _propTypes["default"].array,
    modifiers: _propTypes["default"].array
  }).isRequired,
  btnText: _propTypes["default"].string.isRequired,
  btnAction: _propTypes["default"].func.isRequired,
  color: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['default', 'carousel'])
};
Specials.defaultProps = {
  color: 'orange',
  type: 'default'
};
var _default = Specials;
exports["default"] = _default;